require('angular');
require('./angular-scroll');

module.exports = 'duScroll';



//////////////////
// WEBPACK FOOTER
// ./~/angular-scroll/index.js
// module id = 325
// module chunks = 6